import { render, staticRenderFns } from "./mvp-login.vue?vue&type=template&id=0b776b26&scoped=true&"
import script from "./mvp-login.vue?vue&type=script&lang=js&"
export * from "./mvp-login.vue?vue&type=script&lang=js&"
import style0 from "./mvp-login.vue?vue&type=style&index=0&id=0b776b26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b776b26",
  null
  
)

export default component.exports